import { OnboardingStatus } from '@qdrant/qdrant-cloud-public-api/iam/v1';
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { accountService } from '@/api/services/account';
import { safeAsync } from '@/helpers/errors/safeAsync';
import { AUTH_REDIRECT_URL } from '@/helpers/url';
import { resolveAuthenticatedUser } from '@/routes/_authenticated.resolvers';

export const Route = createFileRoute('/_authenticated/onboarding')({
  beforeLoad: async ({ context }) => {
    const user = await resolveAuthenticatedUser(context);
    const { items: accounts } = await context.queryClient.fetchQuery(context.listAccountsQuery);

    if (accounts.length > 0 || user.onboardingStatus === OnboardingStatus.COMPLETED) {
      throw redirect({ href: AUTH_REDIRECT_URL, replace: true });
    }

    return {
      suggestedCompanyByEmailQuery: {
        ...accountService.suggestCompaniesQuery({
          criteria: { case: 'email', value: user.email },
        }),
        retry: false,
        staleTime: Infinity,
      },
    };
  },
  loader: async ({ context: { queryClient, suggestedCompanyByEmailQuery } }) => {
    await safeAsync(queryClient.ensureQueryData(suggestedCompanyByEmailQuery));
  },
  component: lazyRouteComponent(() => import('./route.component'), 'OnboardingComponent'),
});
